export default "__VITE_ASSET__C8ap$xiI__"